import { useEffect, useState } from "react";
import axios from "axios";
import { Card, CardContent } from "@/components/ui/card";
import { Search } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PlateUsageCard = () => {
  const [u, setU] = useState(null);
  useEffect(() => {
    axios.get(`${API}/admin/plate-usage`).then((r) => setU(r.data)).catch(() => setU(null));
  }, []);
  if (!u) return null;
  const month = new Date(`${u.month}-01`).toLocaleDateString("fr-FR", { month: "long", year: "numeric" });
  return (
    <Card className="border-0 shadow-sm" data-testid="plate-usage-card">
      <CardContent className="p-5 flex flex-wrap items-center gap-x-8 gap-y-3">
        <div className="flex items-center gap-3">
          <Search className="w-5 h-5 text-[#102692]" />
          <div>
            <p className="text-sm text-slate-500">Recherches de plaques — {month}</p>
            <p className="text-2xl font-bold text-slate-900" data-testid="plate-usage-api-calls">{u.api_calls} requête{u.api_calls > 1 ? "s" : ""} API</p>
          </div>
        </div>
        <p className="text-sm text-slate-600" data-testid="plate-usage-cache-hits">{u.cache_hits} réutilisée{u.cache_hits > 1 ? "s" : ""} depuis la mémoire</p>
        <p className="text-sm text-slate-600" data-testid="plate-usage-blocked">{u.blocked} bloquée{u.blocked > 1 ? "s" : ""} (robots ou limite)</p>
        <p className="text-sm text-slate-600" data-testid="plate-usage-cached">{u.cached_plates} plaque{u.cached_plates > 1 ? "s" : ""} en mémoire (30 jours)</p>
      </CardContent>
    </Card>
  );
};
